export default __webpack_public_path__ + "static/media/robot.93d5be81.png";